import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors"
import { HTTP } from "@/utils/http-common"

// Good
const get = function ($, StaffId = null, filters = {}) {
  return new Promise((resolve, reject) => {
    HTTP.get(`/business/${StaffId ? "staff/" + StaffId : "" + "staff"}`,  { params: filters })
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const getAllCfcis = function () {
  return new Promise((resolve, reject) => {
    HTTP.get(`/business/cfsis`)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const create = function ($, cfsi) {
  return new Promise((resolve, reject) => {
    HTTP.post(`business/staff`, cfsi)
      .then(response => resolve(response.data))
      .catch(err => {
        return reject(err)
      })
  })
}

const update = function ($, cfsiId, data) {
  return new Promise((resolve, reject) => {
    HTTP.patch(`/business/staff/${cfsiId}`, data)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const remove = function ($, cfsiId) {
  return new Promise((resolve, reject) => {
    HTTP.delete(`/business/staff/${cfsiId}`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}

const close = function ($, cfsiId) {
  return new Promise((resolve, reject) => {
    HTTP.post(`/business/staff/${cfsiId}/close`)
      .then(response => resolve(response.data))
      .catch(error => {
        new EHC(DEFAULTS_HANDLERS).intercept(error)
        reject(error)
      })
  })
}



// const close = function ($, cfsiId) {
//   return new Promise((resolve, reject) => {
//     HTTP.post(`business/cfsis/${cfsiId}/close`)
//       .then(response => resolve(response.data))
//       .catch(err => {
//         return reject(err)
//       })
//   })
// }

export default {
  get,
  getAllCfcis,
  create,
  update,
  remove,
  close
}
